export default {
  events: {
    left: null, // 'prevImg',
    right: null, // 'nextImg',
    esc: null, // 'closePreview',
    'command i': null, // toggle infopanel
    'command h': null, // toggle historypanel
    'alt 1': null, // 'rating1',
    'alt 2': null, // 'rating2',
    'alt 3': null, // 'rating3',
    'alt 4': null, // 'rating4',
    'alt 5': null, // 'rating5',
  },
};
